<template>
  <div>
    <fieldset v-for="(user, index) in users" :key="user.id" class="custom-fieldset">
      <legend>{{ $t("global.passenger") }} {{ index + 1 }}</legend>
      <admin-passenger-data-preview :user="user" />
    </fieldset>
  </div>
</template>

<script>
import AdminPassengerDataPreview from "./AdminPassengerDataPreview";
export default {
  name: "AdminPassengersDataPreview",
  components: { AdminPassengerDataPreview },
  props: {
    users: {
      required: true,
      type: Array
    }
  }
};
</script>

<style scoped></style>
